
    import { RouterLink } from 'vue-router'
    import { defineComponent } from 'vue'
    import type { BreadcrumbItem } from '../../../types';
    

    export default defineComponent({
        name: 'XBreadcrumb',
        components: {
            RouterLink,
        },
        //props: {
        //    items: {
        //        type: Array<BreadcrumbItem>,
        //        required: false,
        //        default: () => [],
        //    },
        //},
        data() {
            return {
                localItems: [] as Array<BreadcrumbItem>,
            }
        },
        mounted() {
            this.localItems = this.getImplicitItems() 
                       },
        methods: {
            getImplicitItems(): Array<BreadcrumbItem> {
                const paths = this.$route.fullPath.split('/')
                const items: Array<BreadcrumbItem> = []
                let route = ''

                for (const path of paths) {
                    route = `${route}${path}/`
                    const matched = this.$router.match(route)

                    if (matched?.meta?.title) {
                        items.push({
                            text: matched.meta.title(matched),
                            path: matched.path,
                        })
                    }
                }

                return items
            },
        },
    })
